import { Route, Switch } from "wouter";
import "./index.css";
import { LandingPage } from "@/pages/LandingPage";
import { RegisterPage } from "@/pages/RegisterPage";
import { SuccessPage } from "@/pages/SuccessPage";
import { CancelPage } from "@/pages/CancelPage";
import Logo from "@/assets/helpamiAI_logo.png";

function PageLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-w-[320px] min-h-screen grid place-items-center p-4 sm:p-6 md:p-8">
      <main className="w-full max-w-2xl flex flex-col items-center justify-center">
        <img src={Logo} alt="Logo" className="pointer-events-none object-contain mb-8 text-center" />
        {children}
      </main>
    </div>
  );
}

export function App() {
  return (
    <div className="min-w-[320px] min-h-screen">
      <Switch>
        <Route path="/">
          <LandingPage />
        </Route>
        <Route path="/register">
          <PageLayout>
            <RegisterPage />
          </PageLayout>
        </Route>
        <Route path="/register/success">
          <PageLayout>
            <SuccessPage />
          </PageLayout>
        </Route>
        <Route path="/register/cancel">
          <PageLayout>
            <CancelPage />
          </PageLayout>
        </Route>
        <Route>
          <PageLayout>
            <div className="flex justify-center">
              <a href="/" className="text-primary underline">
                Torna alla home
              </a>
            </div>
          </PageLayout>
        </Route>
      </Switch>
    </div>
  );
}

export default App;
